/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Question/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaInputQuestion from 'DesignSystem/TysiaInputQuestion/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Question({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/PreviousQuestions/Content/Questions/Question"
  
}) {
let questionItemIndexValueData = fromData.useDataFormat({ viewPath,
context: 'question_item',
path: 'index',
format: fromFormat.odd,
})
let questionTypeValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'type',
})
let constantData = 'multichoice'
let aggregateData = fromAggregate.equals(questionTypeValueData, constantData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let questionTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'question',
path: 'type',
})
let constantData1 = 'multichoice'
let aggregateData1 = fromAggregate.equals(questionTypeValueData1, constantData1)
  return (<React.Fragment
>
<div
  data-testid="Question.Horizontal"
  data-view-path={viewPath}
 style={{'--pr-1-Z1iwBUS': questionItemIndexValueData ? "0px" : aggregateData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--w-2-Z1iwBUS': aggregateData ? "100%" : "50%"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputQuestion
  viewPath={`${viewPath}/TysiaInputQuestion`}
 marginTop={dtSpaceS}
 isToggle={aggregateData1 ? true : false}
 showAlert={false}
 disabled={true}
 data="question.type"
 data="'multichoice'"
 aggregate="/Data/aggregate.js equals"
/>
</div>
{children}
</React.Fragment>)
}